import { HttpClient } from '../common/httpClient';
import { InvoicePageData } from 'src/types/invoice';

export class WhatsappInvoicesApi {
  constructor(private readonly httpClient: HttpClient) { }

  async getAll(url: string): Promise<InvoicePageData> {
   return await this.httpClient.get(`${url}`)
  }

  async update(id: string, status: string): Promise<void> {
    await this.httpClient.put(`invoices/${id}/${status}`, {});
  }

  async send(id: string): Promise<void> {
    await this.httpClient.get(`invoices/resend/${id}`);
  }

}
